module.exports = {
  title: '访客统计',
  route: {
    path: '/factory-trade-union',
    children: {
      path: 'factory-visitor-trace-list',
    },
  },
};
